import {
   createBooleanSchema,
   createEnumSchema,
   createLiteralSchema,
   createNumberSchema,
   createObjectSchema,
   createStringSchema,
   createUnionSchema,
} from '@dreryk/react-draft';

import { diagnosesWithBodySideFormPart } from '~libs.desktop.shared.visit-medical-documents.diagnoses';

import { addressSchema, countrySchema, postcodeSchema } from '../../../shared/schemas/addressSchema';

import {
   GuardianEnteredByUserFormBean,
   ReferralToPsychiatricHospitalFormGuardian,
   ReferralToPsychiatricHospitalFormGuardianAddress,
} from './ReferralToPsychiatricHospitalForm/fields/GuardianSection/guardianSection.types';
import { ReferralToPsychiatricHospitalFormBean } from './ReferralToPsychiatricHospitalForm/referralToPsychiatricHospitalForm.types';

const guardianSchema = createUnionSchema([
   createLiteralSchema('ENTERED_BY_USER'),
   createObjectSchema<ReferralToPsychiatricHospitalFormGuardian>({
      id: createNumberSchema(),
      firstName: createStringSchema().nullable(),
      lastName: createStringSchema().nullable(),
      address: addressSchema,
   }),
] as const);

const formGuardianAddressSchema = createObjectSchema<ReferralToPsychiatricHospitalFormGuardianAddress>({
   town: createStringSchema().nullable(),
   street: createStringSchema().nullable(),
   building: createStringSchema().nullable(),
   flat: createStringSchema().nullable(),
   postcode: postcodeSchema.nullable(),
   country: countrySchema.nullable(),
});

const guardianEnteredByUserSchema = createObjectSchema<GuardianEnteredByUserFormBean>({
   firstName: createStringSchema().nullable(),
   lastName: createStringSchema().nullable(),
});

export const referralToPsychiatricHospitalDraftSchema = createObjectSchema<ReferralToPsychiatricHospitalFormBean>({
   diagnoses: diagnosesWithBodySideFormPart.draftSchema,
   unitNameAndAddress: createStringSchema().nullable(),
   patientConsent: createEnumSchema(['WITH_CONSENT', 'WITHOUT_CONSENT']),
   statutoryRepresentativeConsent: createEnumSchema(['WITH_CONSENT', 'WITHOUT_CONSENT', 'NOT_APPLICABLE']),
   informationAboutPatient: createEnumSchema([
      'NOT_INCAPACITATED',
      'PARTIALLY_INCAPACITATED',
      'COMPLETELY_INCAPACITATED',
      'NO_INFORMATION',
   ]).nullable(),
   actualGuardian: guardianSchema,
   statutoryRepresentative: guardianSchema,
   otherJustifyingInformation: createStringSchema().nullable(),
   actualGuardianNotApplicable: createBooleanSchema(),
   statutoryRepresentativeNotApplicable: createBooleanSchema(),
   actualGuardianAddress: formGuardianAddressSchema,
   statutoryRepresentativeAddress: formGuardianAddressSchema,
   actualGuardianEnteredByUser: guardianEnteredByUserSchema,
   statutoryRepresentativeEnteredByUser: guardianEnteredByUserSchema,
});
